var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.863701 7.36351C0.51223 7.71498 0.51223 8.28483 0.863701 8.6363L7.8637 15.6363C8.21517 15.9878 8.78502 15.9878 9.13649 15.6363C9.48796 15.2848 9.48796 14.715 9.13649 14.3635L3.67289 8.8999H18.5001C18.9972 8.8999 19.4001 8.49696 19.4001 7.9999C19.4001 7.50285 18.9972 7.0999 18.5001 7.0999L3.67289 7.0999L9.13649 1.6363C9.48796 1.28483 9.48796 0.714977 9.13649 0.363505C8.78502 0.0120335 8.21517 0.0120344 7.8637 0.363506L0.863701 7.36351Z",
    fill: "#1B1C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrowBack.a7a283ec6ecd125960b93adde23f42b3.svg";
export { ForwardRef as ReactComponent };